import React, { FC } from 'react';
import SparkleIcon from '../icons/SparkleIcon';

interface AIBadgeProps {
  title: string;
}

export const AIBadge: FC<AIBadgeProps> = ({ title }) => {
  return (
    <div
      className="
        inline-flex items-center
        gap-[4px]
        px-[10px] py-[5px]
        rounded-[16px]
        text-[14px] leading-[20px] font-medium font-sans
        text-ai-purple
        border-[0.67px] border-[color:var(--ai-blue-1)]/10
      "
      style={{
        background:
          'linear-gradient(90.08deg, rgba(43, 127, 255, 0.3264) -234.41%, rgba(173, 70, 255, 0.064) 130.6%)',
      }}>
      <SparkleIcon className="w-[12px] h-[12px]" />
      <span>{title}</span>
    </div>
  );
};
